export default "__VITE_ASSET__BejBJMiQ__"